export const PAGE_SIZES = {
  SMALL: 10,
  COMPACT: 15,
  STANDARD: 25,
  LARGE: 50,
  DEFAULT: 100,
  /** Server default when the endpoint supports paging and no limit is sent. */
  BULK: 500,
  EXPORT: 5_000_000,
} as const;

export const PAGE_SIZE_OPTIONS = {
  MODAL: [10, 25, 50],
  COMPACT: [15, 25, 50],
  STANDARD: [25, 50, 100],
  /** Server default when the endpoint supports paging and no limit is sent. */
  BULK: [500],
} as const;

/** Reusable initialState.pagination fragment for historical DataGrids */
export const GRID_INITIAL_PAGINATION = {
  paginationModel: { pageSize: PAGE_SIZES.DEFAULT },
} as const;
